import buildRoute from './buildRoute'

export const pingAPI = async () => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'system-monitor-api',
            data: { status: true },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const pingMongo = async () => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'system-monitor-mongo',
            data: { status: true },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const pingSocket = async () => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'system-monitor-socket',
            data: { status: true },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}
